import { render, staticRenderFns } from "./DehorningSecondPage.vue?vue&type=template&id=5e4d104e&scoped=true&"
import script from "./DehorningSecondPage.vue?vue&type=script&lang=js&"
export * from "./DehorningSecondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4d104e",
  null
  
)

export default component.exports